var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.27 7.79c0 1.66-.3 2.64-1.28 4.23-1.01 1.62-2.99 3.21-4.43 3.95l-.46-.89c1.24-.88 2.04-1.57 2.92-3.26.25-.48.39-.9.47-1.28-.19.04-.4.06-.61.06-1.82 0-3.29-1.48-3.29-3.3s1.47-3.3 3.29-3.3c1.51 0 2.79 1.02 3.17 2.42.14.4.22.85.22 1.37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.68 7.79c0 1.66-.3 2.64-1.28 4.23-1.01 1.62-2.99 3.21-4.43 3.95l-.46-.89c1.24-.88 2.04-1.57 2.92-3.26.25-.48.39-.9.47-1.28-.19.04-.4.06-.61.06-1.82 0-3.29-1.48-3.29-3.3s1.47-3.3 3.29-3.3c1.51 0 2.79 1.02 3.17 2.42.14.4.22.85.22 1.37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.62ae834549b2242cd4922eb4c796ec0b.svg";
export { ForwardRef as ReactComponent };